import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import NavItem from './NavItem';
import './SideBar.scss';
import { getCurrentUser, RMHelpURL, RMLiteHelpURL } from 'utils/Global';
import RMModal from 'components/modal/RMModal';
import { ChangePassword } from 'components/main/userGroup';
import NotificationsPanel from './NotificationsPanel';
import { useRMDispatch } from 'redux/hooks';
import { setProductEdition } from 'redux/reducers/experimentReducer';
import LicenseService from 'business/services/LicenseService';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import useRMLite from 'CustomHooks/useRMLite';

const modalDefaultState = {
  heading: '',
  content: null,
  show: false,
  showButtons: false,
  okButtonText: '',
  noButtonText: '',
  dialogClassName: '',
  titleClr: '',
};

function FragmentSidebar() {
  const history = useHistory();
  const USER = 'USER';
  const HELPANDSUPPORT = 'HELPANDSUPPORT';
  const [openedNavItem, setOpenedNavItem] = useState({ value: USER });
  const [modalDetails, setModalDetails] = useState(modalDefaultState);
  const [showModal, setShowModal] = useState(false);
  const rmLite = useRMLite();
  const dispatch = useRMDispatch();
  const _setProductEdition = useCallback(
    (productEdition: string) => dispatch(setProductEdition(productEdition)),
    [dispatch],
  );

  const onNavItemClick = (navItemId) => {
    if (openedNavItem.value === navItemId) {
      setOpenedNavItem({ value: null });
    } else {
      setOpenedNavItem({ value: navItemId });
    }
    if (navItemId === 'HELPANDSUPPORT') {
      window.open(rmLite ? RMLiteHelpURL : RMHelpURL, 'webhelp');
    }
  };

  useEffect(() => {
    const licenseService = new LicenseService();
    licenseService
      .getLicenseDetails()
      .then((res) => _setProductEdition(res.licProduct.edition));
    const user = getCurrentUser();

    if (user?.shouldResetPassword) {
      handleChangePassword();
    }
  }, []);

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
    setModalDetails(modalDefaultState);
  }, [modalDefaultState]);

  const handleChangePassword = useCallback(() => {
    setShowModal(true);
    setModalDetails({
      ...modalDetails,
      show: true,
      heading: 'Change User Password',
      content: <ChangePassword closeModal={handleCloseModal} />,
      showButtons: false,
      okButtonText: '',
      noButtonText: '',
    });
  }, [setModalDetails]);

  return (
    <div id='fragmentsidebar-wrapper' className="sidebar border-sidebar h-100">
      <NotificationsPanel key={'user'} />
      {
        <NavItem
          to={`${history?.location?.pathname ? history?.location?.pathname : ''}`}
          label="Fragment"
          key="fragment"
          icon={<RMSvgIcon id='fragmentsidebar-fragment-icon' name="Fragment" subfolder="Fragment" />}
          onClick={() => {}}
        />
      }
      {
        <NavItem
          to={`${history?.location?.pathname ? history?.location?.pathname : ''}`}
          label="Help"
          key="help"
          icon={<RMSvgIcon id='fragmentsidebar-help-icon' name="Help" fill={'#ffffff'} />}
          onClick={() => onNavItemClick(HELPANDSUPPORT)}
        />
      }
      <RMModal
        id='fragmentsidebar-modal'
        setShowModal={setShowModal}
        showModal={showModal}
        body={modalDetails.content}
        heading={modalDetails.heading}
        showButtons={modalDetails.showButtons}
        okButtonText={modalDetails.okButtonText}
        noButtonText={modalDetails.noButtonText}
        dialogClassName={modalDetails.dialogClassName}
        titleClr={modalDetails.titleClr}
      />
    </div>
  );
}
export default FragmentSidebar;
